const enabledFacilities = [
	'0005',
	'0030',
	'0334',
	'0348',
	'0350',
	'0363',
	'0402',
	'1029',
	'1038',
	'1039',
	'1320',
	'1328',
	'1416',
	'1453',
	'1462',
	'1478',
	'1498',
	'2032',
	'2069',
	'2072',
	'2077',
	'2100',
	'2131',
	'2146',
	'2158',
	'2161',
	'2303',
	'2349',
	'2354',
	'2356',
	'2360',
	'2361',
	'2379',
	'2382',
	'2390',
	'2394',
	'2399',
	'2402',
	'2443',
	'2454',
	'2480',
	'3001',
	'3007',
	'3059',
	'3075',
	'3093',
	'3101',
	'3102',
	'3112',
	'3116',
	'3119',
	'3128',
	'3133',
	'3134',
	'3135',
	'3147',
	'3152',
	'3156',
	'3160',
	'3161',
	'3163',
	'3166',
	'3168',
	'3314',
	'3330',
	'3335',
	'3338',
	'3353',
	'3360',
	'3369',
	'3371',
	'3386',
	'3400',
	'3407',
	'4005',
	'4007',
	'4016',
	'4021',
	'4022',
	'4026',
	'4031',
	'4033',
	'4035',
	'4038',
	'4040',
	'4043',
	'4045',
	'4050',
	'4051',
	'4052',
	'4059',
	'4062',
	'4068',
	'4069',
	'4083',
	'4089',
	'4099',
	'4107',
	'4113',
	'4115',
	'4119',
	'4121',
	'4128',
	'4129',
	'4133',
	'4134',
	'4136',
	'4138',
	'4144',
	'4148',
	'4153',
	'4162',
	'4164',
	'4165',
	'4168',
	'4173',
	'4181',
	'4183',
	'4186',
	'4197',
	'4198',
	'4206',
	'4207',
	'4210',
	'4217',
	'4222',
	'4224',
	'4227',
	'4237',
	'4247',
	'4250',
	'4251',
	'4254',
	'4262',
	'4265',
	'4266',
	'4267',
	'4268',
	'4269',
	'4271',
	'4272',
	'4274',
	'4276',
	'4283',
	'4289',
	'4291',
	'4292',
	'4303',
	'4318',
	'4320',
	'4321',
	'4322',
	'4332',
	'4334',
	'4336',
	'4346',
	'4347',
	'4349',
	'4350',
	'4352',
	'4356',
	'4361',
	'4365',
	'4371',
	'4375',
	'4386',
	'4387',
	'6326',
	'7334',
	'7352',
	'7356',
	'7427',
	'7467',
	'8373',
	'8420',
	'8490',
	'9341',
	'9387',
	'9451',
];

const facilitySupportsLanguageToggle = (facilityCode: string) => {
	return enabledFacilities.includes(facilityCode);
};

export default facilitySupportsLanguageToggle;
